import { useAsyncData } from '#imports'

import { useAlgoliaSearchOptions } from '@backmarket/nuxt-layer-algolia/useAlgoliaSearchOptions'
import {
  type AlgoliaHit,
  algoliaHitToBuybackProduct,
  getBuybackSearchConfiguartion,
} from '@backmarket/nuxt-layer-buyback/composables/buybackSearch/useBuybackSearch'
import algoliasearch from 'algoliasearch'

export async function useSeoProductById(objectId: string) {
  const algoliaSearchOption = useAlgoliaSearchOptions('buyback')

  const {
    data: product,
    pending: isLoading,
    error,
  } = await useAsyncData(`seo-product-${objectId}`, async () => {
    const config = await getBuybackSearchConfiguartion('descending-gmv-search')

    if (!config.data.value?.indexName || !objectId) {
      return null
    }

    const algoliaIndex = algoliasearch(
      'dummy_app_id',
      'dummy_key',
      algoliaSearchOption,
    ).initIndex(config.data.value.indexName)

    const searchResult = await algoliaIndex.search<AlgoliaHit>('', {
      filters: `objectID:${objectId}`,
      hitsPerPage: 1,
    })

    if (searchResult.hits.length === 0) {
      return null
    }

    return algoliaHitToBuybackProduct(searchResult.hits[0])
  })

  return {
    product,
    isLoading,
    error,
  }
}
